import React, { useState } from "react"
import { graphql, Link } from "gatsby"
import CustomMarkdown from "../utils/customMarkdown"
import "../scss/branch.scss"
import SEO from "../components/seo"
import Layout from "../components/layout"
import useSiteMetadata from "../utils/useSiteMetadata"

import SubheadingText from "../components/basic-components/subheading-text"

import Img from "gatsby-image";
import GetImgUrl from "../utils/customFunctions";

import loadable from '@loadable/component'

import { FaCheckCircle } from "react-icons/fa";

const Button = loadable(() => import("../components/basic-components/button"))
const Signup = loadable(() => import("../components/signup"))
const Branches = loadable(() => import("../components/branches-component"))
const Tiles = loadable(() => import("../components/tiles"))
const Hero = loadable(() => import("../components/basic-components/hero"))
const QuoteCarousel = loadable(() => import("../components/quote-carousel"))
const Paragraph = loadable(() => import("../components/paragraph"))
const VideoComponent = loadable(() => import("../components/video-component"))
const StepsComponent = loadable(() => import("../components/steps-component"))
const FAQComponent = loadable(() => import("../components/faq-component"))
const SwirlComponent = loadable(() => import("../components/swirl-component"))
const MapComponent = loadable(() => import("../components/map-component"))
const BranchLocator = loadable(() => import("../components/branch-locator"))
const HtmlEditor = loadable(() => import("../components/html-editor"))
const InfiniteImageCarousel = loadable(() => import("../components/infinite-image-carousel"))
const InfiniteTextCarousel = loadable(() => import("../components/infinite-text-carousel"))

export const query = graphql`
{
  strapiContactPage {
    SEOTitle
    SEODescription
    Canonical
    MetaTags{
      MetaName
      MetaContent
    }
    Address
    BranchName
    ContactFormToken
    Email
    Subheader
    HeaderImage {
      localFile{
        publicURL
        childImageSharp{
          fluid(quality: 90, maxWidth: 1900) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
    PhoneNo
    strapiId
    OpeningHours
    GMapsLocation
    PageComponents
  }

  allStrapiBranches {
    edges {
      node {
        BranchName
        Slug
        strapiId
        Email
        PhoneNo
      }
    }
  }
}
`

  // staticMap(nickname: {eq: "contact"}) {
  //   childFile {
  //     publicURL
  //   }
  //   mapUrl
  // }

const Contact = ({ data, pageContext }) => {

  var headerData = {
    headerTitle: data.strapiContactPage.BranchName,
    headerDescription: "",
    headerCTAPrimaryLabel: "",
    headerCTAPrimaryUrl: "",
    headerCTASecondaryLabel: "",
    headerCTASecondaryUrl: "",
    headerBgImage: data.strapiContactPage.HeaderImage.localFile.childImageSharp.fluid,
    headerRightBgColor: "",
    headerLeftBgColor: '',
  };

  const [visible, setVisible] = useState(true);

  const pageHasHeader = data.strapiContactPage.Header != null ? true : false; //check if Header is set
  const [headerParagraphSet, setHeaderParagraphSet] = useState(false);

  
  const sendBranchMessage = event => {

    var form = document.getElementById("branch-contact-form")
    // console.log(form.elements["branchmessage-enquiry-type"].value) //returns selected radio option
    // console.log(form)


    var cform = {
      FirstName: form.elements["branchmessage-first-name"].value,
      LastName: form.elements["branchmessage-last-name"].value,
      Email: form.elements["branchmessage-email"].value,
      PhoneNo: form.elements["branchmessage-phone-no"].value,
      // EnquiryType: form.elements["branchmessage-enquiry-type"].value,
      Message: form.elements["branchmessage-message"].value,
      AcceptOffers: form.elements["branchmessage-offers"].checked,
    }

    // console.log(cform)


    var submitBtn = document.getElementById("sendBranchMessage").firstChild;
    submitBtn.innerHTML = '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" class="spinner" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"></path></svg>';
    submitBtn.classList.add("form-submitting");

    var body = {
      Token: data.strapiContactPage.ContactFormToken,
      FormData: JSON.stringify(cform)
    };

    // console.log(body, "message sent!")

    fetch("https://api.phaeria.com/api/home/SendEmailNotification", {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response =>
      response.text().then(function (responseText) {
        // console.log("response text: " + responseText);
        if (responseText.localeCompare('"Form sent successfully."') === 0) {
          //success send message
          // console.log("success"+ responseText);
          submitBtn.innerHTML = "Thanks for reaching out, we’ll be in touch shortly.";
          submitBtn.classList.remove("form-submitting");
          submitBtn.classList.add("hide-btn");
          setVisible(false);

        } else {
          //error sending message
          // console.log("something went wrong");
          submitBtn.innerHTML = "Oops... Try again!";
          submitBtn.classList.remove("form-submitting");
        }


      })
    )
    let spamDomains = ["mailinator", "aosod.com", "guerrillamail", "spam4.me", "pokemail.net", "sharklasers.com", "tcwlx.com", "yopmail.com", "nfstripss.com", "maildrop.cc"];
    let isSpam = 0
    spamDomains.forEach(function (domain, index) {
      if (JSON.stringify(cform).includes(domain)) {
        isSpam = 1;
      }
    });

    if (isSpam == 0) {
      fetch("https://api.phaeria.com/api/home/SendEmailNotification", {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response =>
        response.text().then(function (responseText) {
          // console.log("response text: " + responseText);
          if (responseText.localeCompare('"Form sent successfully."') === 0) {
            //success send message
            // console.log("success"+ responseText);
            submitBtn.innerHTML = "Thanks for reaching out, we’ll be in touch shortly.";
            submitBtn.classList.remove("form-submitting");
          } else {
            //error sending message
            // console.log("something went wrong");
            submitBtn.innerHTML = "Oops... Try again!";
            submitBtn.classList.remove("form-submitting");
          }


        })
      )
    }
    else {

      submitBtn.innerHTML = "Thanks for reaching out, we’ll be in touch shortly.";
      submitBtn.classList.remove("form-submitting");
    }
    // end of fetch

    // console.log("Message sent");

    event.preventDefault();
  }

  const handleGtag = (title) => {
    if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {

      window.gtag('event', 'contact-form', { 'event_category': 'ecommerce', 'event_label': `${title}` });

    }
  }

  const handleGtagHQPhone = (title) => {
    if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {

      window.gtag('event', 'branch-call', { 'event_category': 'ecommerce', 'event_label': `${title}` });

    }
  }

  const handleGtagHQEmail = (title) => {
    if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {

      window.gtag('event', 'branch-email', { 'event_category': 'ecommerce', 'event_label': `${title}` });

    }
  }

  const handleGtagBranchPhone = (title) => {
    if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {

      window.gtag('event', 'branch-call', { 'event_category': 'ecommerce', 'event_label': `${title}` });

    }
  }

  const handleGtagBranchEmail = (title) => {
    if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {

      window.gtag('event', 'branch-email', { 'event_category': 'ecommerce', 'event_label': `${title}` });

    }
  }

  const { siteUrl: url } = useSiteMetadata();

  return (
    <div>
      <Layout pageData={headerData} headerShow={true} headerType="contact">
        <SEO title={data.strapiContactPage.SEOTitle} description={data.strapiContactPage.SEODescription} 
             meta={data.strapiContactPage.MetaTags}
             canonical={data.strapiContactPage.Canonical ? data.strapiContactPage.Canonical : `${url}`}/>

      {data.strapiContactPage.Subheader ? <SubheadingText text={data.strapiContactPage.Subheader} /> : ''}     
       
        <div className="branch-page-wrapper">
          <div className="branch-page lateral-padding">

            <section className="white-section branch-details">

              <h2 className="">Our Details</h2>
              
              <div className="details-section">
                <div className="uk-grid-collapse uk-child-width-expand@s" data-uk-grid>
                  <div>
                    <div className="details-text multiline-text" dangerouslySetInnerHTML={{ __html: data.strapiContactPage.Address }}></div>
                    <div className="">
                      <div onClick={() => handleGtagBranchPhone(data.strapiContactPage.BranchName)}>
                      
                      <a href={`tel:${data.strapiContactPage.PhoneNo}`} className="phone-link">{data.strapiContactPage.PhoneNo}</a>
                      </div>
                      <div className="branch-email phone-link" onClick={() => handleGtagBranchEmail(data.strapiContactPage.BranchName)}><a href={"mailto:" + data.strapiContactPage.Email}>{data.strapiContactPage.Email}</a></div>
                    
                      <div>
                        <div className="column-title">Opening Hours</div>
                        <div className="details-text" dangerouslySetInnerHTML={{ __html: data.strapiContactPage.OpeningHours }}></div>
      
                      </div>
                    </div>
                  </div>

                  <div>
                    
                    <div className="map-section">
  
                      {/* {data.staticMap?
                      <a href={data.staticMap.mapUrl} target="_blank">
                        <div className="image-section uk-height-medium uk-cover-container uk-margin-none">
                          <img src={data.staticMap.childFile.publicURL||""} alt={data.strapiContactPage.BranchName + " map"} data-uk-cover/>
                        </div>
                      </a>:<div className="image-section uk-cover-container uk-margin-none"></div>
                      } */}
                      {
                        data.strapiContactPage.GMapsLocation ? 
                          <HtmlEditor htmlContent={data.strapiContactPage.GMapsLocation}></HtmlEditor>
                        :<div className="image-section uk-cover-container uk-margin-none"></div>
                      }

                    </div>
                  </div>
                </div>
              </div>


              <div className="enquiry-btn-wrap">
                  <a href="#enquiry-popup" aria-label="enquiry button">
                      <Button use="" label="Enquiry"></Button>
                  </a>
              </div>              

            </section>


            <section className="white-section other-branches margin-top">
              <h2 className="">Our other branches</h2>

              <div uk-grid class="uk-grid uk-grid-column-small uk-grid-row-small uk-child-width-1-2@s uk-child-width-1-3@m uk-child-width-1-4@l  uk-child-width-1-5@xl uk-text-center" >
                {data.allStrapiBranches.edges.map((item, index) => {
                  return (
                    <div key={index} className="other-branch-wrap ">
                      <div className="uk-card uk-card-default uk-card-body">

                        <div className="branch-name-fs">{item.node.BranchName}</div>
                        <div><Link to={"/branch/" + item.node.Slug.replace(/[\s+.]/g, '-').replace(/[*+~.,_^&#£%|()'"?!:@]/g, '').toLowerCase()} className='branch-name-fs'>Find out more</Link></div>
                      
                        <div onClick={() => handleGtagBranchPhone(item.node.BranchName)}><a href={`tel:${item.node.PhoneNo}`} className="phone-link">{item.node.PhoneNo}</a></div>
                        <div className="branch-email phone-link" onClick={() => handleGtagBranchEmail(item.node.BranchName)}><a href={"mailto:" + item.node.Email}>{item.node.Email}</a></div>
                        
                      </div>

                    </div>
                  )
                })}
              </div>

            </section>

            </div>

              {data.strapiContactPage.PageComponents.map((item, index) => {
              switch (item.strapi_component) {
                case "basic-components.paragraph":
                  var forceH1Title = false;
                  var overlaySwirl = false;
                  if((pageHasHeader == false && headerParagraphSet == false) || item.IsHeader == true){
                    setHeaderParagraphSet(true);
                    forceH1Title = true;
                  }

                  if(index == 0 && item.TopSwirl == true){ //if paragraph is the first item in pageComponents and has topSwirl then overlay the header image
                    overlaySwirl = true;
                  }
                  return (               
                      <Paragraph
                          key={index}
                          title={item.Title}
                          text={item.Text}
                          image={item.Image}
                          imagePosition={item.ImagePosition}
                          bgColor={item.BackgroundColor || ""}
                          topPadding={(item.TopPadding === true) ? true : false}
                          bottomPadding={(item.BottomPadding === true) ? true : false}
                          forceH1Title={forceH1Title}
                          alignment={item.ContentAlignment}
                          initialPadding={item.InitialPadding}
                          topSwirl={item.TopSwirl}
                          bottomSwirl={item.BottomSwirl}
                          bottomMargin={item.BottomMargin}
                          overlaySwirl={overlaySwirl}
                          leftPadding={item.LeftPadding}
                          rightPadding={item.RightPadding}
                      ></Paragraph>
                  )
                case "basic-components.hero-section":
                  return(
                    <Hero
                      title={item.Hero.Title}
                      description={item.Hero.Description}
                      label={item.Hero.Label}
                      url={item.Hero.url}
                      key={index}
                      sectionStyle = "white"
                    ></Hero>
                  )
                case "basic-components.branches-component":
                  const branchesBgColor = item.BackgroundColor != null ? item.BackgroundColor.toLowerCase() : 'dark'; 
                  return(
                    <Branches key={index} branchList={item.BranchesList} title={item.Title} sectionStyle={branchesBgColor} />
                  )
                case "basic-components.video-section":
                  return(
                    <VideoComponent key={index} src={item.YoutubeURL}/>
                  )
                case "basic-components.testimonial-section":
                  return(
                      <div key={index} className="">
                        <QuoteCarousel quoteList={item.Testimonial}></QuoteCarousel>
                      </div>
                  )
                case "cta.cta-section":
                  const sectionBgColor = item.BackgroundColor != null ? item.BackgroundColor.toLowerCase() : 'dark'; 
                  const fullWidthSectionBgColo =  item.BackgroundColor != null ? item.BackgroundColor.toLowerCase() : 'white'; 
                  return(
                    <div key={index}>
                      {item.CTA !== undefined && item.CTA.length > 1 ? (<Tiles data={item.CTA} width='half' key={index} sectionStyle={sectionBgColor}></Tiles>) : ("")}

                      {item.CTA !== undefined && item.CTA.length === 1 ? (<Tiles data={item.CTA} key={index} singleFlag={true} width='full' sectionStyle={fullWidthSectionBgColo}></Tiles>) : ("")
                        // (item.CTA !== null && Object.keys(item.CTA).length === 1)?<Tiles data={item.CTA} singleFlag={true}></Tiles>:""
                        //don't forget to fix this once the cta.length of a json (dynamic zone) is found
                      }
                    </div>
                  )
                  case "basic-components.text-section":
                    return (               
                      item.Text ? (
                        <>
                          <CustomMarkdown key={index} children={item.Text} />
                              {item.Links 
                                ?<Link to={`${item.Links.URL}`}>
                                    {item.Links.Link}
                                  </Link>  
                                : ''}
                        </>
                      ) : (
                        ""
                      )
                    )
                  case "basic-components.image-carousel":
                    return (               
                      item.Images 
                        ? ( <div key={index} className="image_wrap">
                          <div className="image-section uk-cover-container uk-margin-none">
                            {/* <img src={item.Images.publicURL} alt="" data-uk-cover/> */}
                            <Img
                              // fluid={item.Images.childImageSharp.fluid}
                              fluid={GetImgUrl(item.Images.localFile___NODE).fluid}
                              alt={"image"}
                              data-uk-cover
                            ></Img>
                          </div>
                        </div>
                        ) 
                        : ("")
                    )
                  case "basic-components.image-carousel-section":
                    return(
                        item.ImageCarousel ? (
                            <div key={index} className="image-section uk-height-medium uk-cover-container uk-margin-none">
                              <Img
                                fluid={
                                  GetImgUrl(item.ImageCarousel.Images.localFile___NODE)
                                    .fluid
                                }
                                alt="image"
                              ></Img>
                            </div>
                        ) : null
                    )
                  case "basic-components.steps-component":
                    return(
                      <StepsComponent key={index} stepsList={item.StepsList} sectionStyle="white" />
                    )
                  case "basic-components.faq-component":
                    return(
                      <FAQComponent key={index} faqList={item.FAQList} sectionStyle="white" />
                    )             
                  case "basic-components.signup-component":
                    return(
                      <Signup
                        title="Sign Up to Our Newsletter"
                        description="Get updates on all the lastest information, or stay informed about our courses"
                        buttonLabel="Sign Up"
                        sectionStyle = "white"
                      />
                    )
                  case "basic-components.swirl-component":                
                    return(
                      <SwirlComponent 
                        key={index} 
                        bgColor={item.SwirlColor} topSwirl={item.Position == "Top" ? true : false} 
                        />
                    )
                  case "basic-components.map-component":                
                    return(
                      <MapComponent 
                        key={index} 
                        title={item.Title}
                        gMapsLocation={item.GMapsLocation} 
                        />
                    )
                  case "basic-components.branch-locator":                
                    return(
                      <BranchLocator 
                        key={index} 
                        title={item.Title}
                        subtitle={item.Subtitle}
                        branchesList={item.Branches} 
                        />
                    )
                  case "basic-components.infinite-image-carousel":                
                    return(
                      <InfiniteImageCarousel 
                        key={index} 
                        title={item.Title}
                        imageList={item.LinkImageList} 
                        backgroundColor={item.BackgroundColor}
                        />
                    )
                  case "basic-components.infinite-text-carousel":                
                    return(
                      <InfiniteTextCarousel 
                        key={index} 
                        title={item.Title}
                        textList={item.LinkTextList} 
                        backgroundColor={item.BackgroundColor}
                        />
                    )
                  default:
                    return ('')
            }
          }
          )} 



          {/* <Signup
            title="Sign Up to Our Newsletter"
            description="Get updates on all the lastest information, or stay informed about our courses"
            buttonLabel="Sign Up"
          /> */}




        </div>


      </Layout>



    </div>
  )
}

export default Contact